const ShipmentStatus = {
  New: 'New',
  PartiallyFulfilled: 'PartiallyFulfilled',
  ReadyToShip: 'ReadyToShip',
  PickedUp: 'PickedUp',
  InTransit: 'InTransit',
  OutForDelivery: 'OutForDelivery',
  Delivered: 'Delivered',
  Exception: 'Exception',
  CanceledByCarrier: 'CanceledByCarrier',
  Canceled: 'Canceled'
};

const FulfillmentType = {
  Delivery: 'delivery',
  Return: 'return'
};

const statusBadgeTypeMapping = {
  [ShipmentStatus.New]: 'new',
  [ShipmentStatus.PartiallyFulfilled]: 'partially-fulfilled',
  [ShipmentStatus.ReadyToShip]: 'ready-to-ship',
  [ShipmentStatus.PickedUp]: 'picked-up',
  [ShipmentStatus.InTransit]: 'in-transit',
  [ShipmentStatus.OutForDelivery]: 'out-for-delivery',
  [ShipmentStatus.Delivered]: 'delivered',
  [ShipmentStatus.Exception]: 'exception',
  [ShipmentStatus.CanceledByCarrier]: 'canceled-by-carrier',
  [ShipmentStatus.Canceled]: 'canceled'
};

const statusDescription = {
  [ShipmentStatus.New]: 'Order created in the system and does not have at least one shipment with the following',
  [ShipmentStatus.PartiallyFulfilled]: 'Order created in the system and has some of the inventory packaged and booked',
  [ShipmentStatus.ReadyToShip]: 'All inventory in order are packaged and booked.',
  [ShipmentStatus.PickedUp]: 'All packages in the order are picked up by the carrier.',
  [ShipmentStatus.InTransit]: 'Based on the carrier tracking information',
  [ShipmentStatus.OutForDelivery]: 'Based on the carrier tracking information',
  [ShipmentStatus.Delivered]: 'Based on the carrier tracking information',
  [ShipmentStatus.Exception]: 'Based on the carrier tracking information',
  [ShipmentStatus.CanceledByCarrier]: 'When the carrier cancels the delivery before they picked up the order',
  [ShipmentStatus.Canceled]: 'When the order is cancelled by the retailer'
};

const accountEnvs = {
  production: 0,
  test: 1,
  internal: 2,
  carrier: 3
};

const FulfillmentMethod = {
  DIRECT: 'direct',
  PUDO: 'pudo'
};

const ShipmentEventType = {
  StatusUpdate: 'status_update',
  Checkpoint: 'checkpoint',
  CarrierAssignmentFailure: 'carrier_assignment_failure',
  CarrierCancellationFailure: 'carrier_cancellation_failure',
  Created: 'created',
  Updated: 'updated',
  CarrierAssignmentSuccess: 'carrier_assignment_success',
  CarrierCancellationSuccess: 'carrier_cancellation_success',
  WebhookSent: 'webhook_sent',
  PrintJobCreated: 'print_job_created'
};

const printLabelTypes = {
  PDF: 'PDF',
  ZPL: 'ZPL'
};

const Role = {
  Admin: 'Admin',
  Packer: 'Packer',
  CustomerService: 'Customer service'
};

const SpecialServices = {
  hazardous: 'HAZARDOUS',
  fragile: 'FRAGILE',
  age_restricted: 'AGE_RESTRICTED'
};

const AddressType = {
  SENDER: 'sender',
  RECIPIENT: 'recipient',
  BILLING: 'billing',
  OTHER: 'other'
};

const ShipmentPackageStatus = {
  ReadyToShip: 'ReadyToShip',
  PickedUp: 'PickedUp',
  InTransit: 'InTransit',
  OutForDelivery: 'OutForDelivery',
  Delivered: 'Delivered',
  Exception: 'Exception',
  CanceledByCarrier: 'CanceledByCarrier'
};

const ShipmentPackageEventType = {
  StatusUpdate: 'status_update',
  Checkpoint: 'checkpoint'
};

export const postcodesDistrictsNorthIreland = [
  'BT18',
  'BT19',
  'BT20',
  'BT21',
  'BT22',
  'BT23',
  'BT24',
  'BT25',
  'BT26',
  'BT27',
  'BT28',
  'BT29',
  'BT30',
  'BT31',
  'BT32',
  'BT33',
  'BT34',
  'BT35',
  'BT36',
  'BT37',
  'BT38',
  'BT39',
  'BT40',
  'BT41',
  'BT42',
  'BT43',
  'BT44',
  'BT45',
  'BT46',
  'BT47',
  'BT48',
  'BT49',
  'BT51',
  'BT52',
  'BT53',
  'BT54',
  'BT55',
  'BT56',
  'BT57',
  'BT58',
  'BT60',
  'BT61',
  'BT62',
  'BT63',
  'BT64',
  'BT65',
  'BT66',
  'BT67',
  'BT68',
  'BT69',
  'BT70',
  'BT71',
  'BT74',
  'BT75',
  'BT76',
  'BT77',
  'BT78',
  'BT79',
  'BT80',
  'BT81',
  'BT82',
  'BT92',
  'BT93',
  'BT94',
  'BT1',
  'BT2',
  'BT3',
  'BT4',
  'BT5',
  'BT6',
  'BT7',
  'BT8',
  'BT9',
  'BT10',
  'BT11',
  'BT12',
  'BT13',
  'BT14',
  'BT15',
  'BT16',
  'BT17'
];

export {
  accountEnvs,
  AddressType,
  FulfillmentMethod,
  FulfillmentType,
  printLabelTypes,
  Role,
  ShipmentEventType,
  ShipmentPackageEventType,
  ShipmentPackageStatus,
  ShipmentStatus,
  SpecialServices,
  statusBadgeTypeMapping,
  statusDescription
};
